import { useMatchMedia } from '@urbantxt/styles';

export { useMatchMedia };
export default useMatchMedia;
